var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1319_56314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6667 7H11.6667C10.429 7 9.242 7.49167 8.36683 8.36683C7.49167 9.242 7 10.429 7 11.6667V44.3333C7 45.571 7.49167 46.758 8.36683 47.6332C9.242 48.5083 10.429 49 11.6667 49H25.6667V7ZM30.3333 49H44.3333C45.571 49 46.758 48.5083 47.6332 47.6332C48.5083 46.758 49 45.571 49 44.3333V11.6667C49 10.429 48.5083 9.242 47.6332 8.36683C46.758 7.49167 45.571 7 44.3333 7H30.3333V49Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1319_56314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.e6fb1132b1c99e390268349eca61dd8d.svg";
export { ForwardRef as ReactComponent };